import { render, staticRenderFns } from "./waterSign.vue?vue&type=template&id=10939e86&scoped=true&"
import script from "./waterSign.vue?vue&type=script&lang=js&"
export * from "./waterSign.vue?vue&type=script&lang=js&"
import style0 from "./waterSign.vue?vue&type=style&index=0&id=10939e86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10939e86",
  null
  
)

export default component.exports